import { FormEvent, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { userService } from '../services/userService';
import Button from './Button';

const ProfilePictureUploader = () => {
  const { user, refreshProfile } = useAuth();
  const [file, setFile] = useState<File | null>(null);
  const [status, setStatus] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    if (!file) return;
    setLoading(true);
    setStatus(null);
    setError(null);
    try {
      await userService.uploadProfilePicture(file);
      await refreshProfile();
      setStatus('Profile picture updated');
      setFile(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to upload avatar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="card" onSubmit={handleSubmit}>
      <h3>Profile picture</h3>
      <p style={{ color: 'var(--gray)' }}>Upload a fresh avatar to keep your Gate.haus profile up to date.</p>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
        <img
          src={user?.profile_picture || 'https://placehold.co/100x100?text=GH'}
          alt="Current avatar"
          width={80}
          height={80}
          style={{ borderRadius: '50%', objectFit: 'cover' }}
        />
        <input type="file" accept="image/*" onChange={(event) => setFile(event.target.files?.[0] || null)} />
      </div>
      {status && <p style={{ color: 'var(--success)' }}>{status}</p>}
      {error && <p style={{ color: 'var(--danger)' }}>{error}</p>}
      <Button type="submit" disabled={!file} loading={loading}>
        Upload new avatar
      </Button>
    </form>
  );
};

export default ProfilePictureUploader;
